import styled from 'styled-components';
import { primitives } from '@veneer/primitives';
import { Accordion } from '@veneer/core';
const { color, layout, typography } = primitives;
export const StyledAccordion123 = styled(Accordion)`
  font-family: ${typography.family0};
  font-style: normal;
`;
export const StyledAccordion = styled(Accordion)`
  && {
    h3 {
      margin-bottom: 0px;
    }
    h3 > button {
      padding: ${typography.size3} ${typography.size2} ${typography.size3}
        ${typography.size0};
      text-align: left;
      justify-content: space-between;
    }
    div {
      line-height: ${typography.lineHeight2};
      margin-left: 0;
    }
  }
  div[role='button'] {
    display: flex;
    justify-content: space-between;
    overflow: visible;

    svg {
      display: flex;
      align-self: start;
    }
  }
`;
export const AccordionItemWrapper = styled.div`
  margin-bottom: ${typography.size0};
`;
export const AccordionHeaderWrapper = styled.div`
  font-family: ${typography.family0};
  font-style: normal;
  font-weight: ${typography.weight3};
  font-size: ${typography.size2};
  line-height: ${typography.lineHeight2};
  color: ${color.gray11};
`;

export const AccordionContentWrapper = styled.div`
  font-family: ${typography.family0};
  font-style: normal;
  font-weight: ${typography.weight3};
  font-size: ${typography.size2};
  line-height: ${typography.lineHeight3} !important;
  color: #636363;
  padding: 0px 4px 4px 4px;
`;
export const CardTitle = styled.p`
  color: ${color.gray12};
  font-size: ${typography.size7};
  line-height: ${typography.lineHeight5};
  margin-bottom: ${typography.size2};
  font-weight: ${typography.weight4};
  font-family: ${typography.family0};
`;
export const DiscrepancyText = styled.p`
  margin-top: ${layout.size6};
  font-size: ${typography.size0};
  line-height: ${typography.lineHeight1};
  color: ${color.gray7};
  margin-top: 40px;
  a {
      cursor: pointer;
      text-decoration: underline;
      color: ${color.electricBlue7};
      &:hover,
      &:active {
        color: ${color.electricBlue7};
      }
`;
